import { render } from "./Invoice_config.vue?vue&type=template&id=9f865ad0&scoped=true"
import script from "./Invoice_config.vue?vue&type=script&lang=js"
export * from "./Invoice_config.vue?vue&type=script&lang=js"

import "./Invoice_config.vue?vue&type=style&index=0&id=9f865ad0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f865ad0"]])

export default __exports__